import PromoServiceApolloConnector from '../../services/PromoServiceApolloConnector';
import { AUTH_TOKEN } from '../../helper/constants';
import { deleteCookieItem, setCookieItem } from '../../helper/cookies';
import { setErrorMsg, setUser } from '../../slices/user/reducer';
import {
  USER_LOGIN,
  USER_PROFILE,
  CREATE_OR_UPDATE_USER,
  GET_USERS,
  UPDATE_DASHBOARD_SETTINGS,
} from '../../gql/user';
import { errorHandling } from '../../helper/errorHandling';
import { ROUTE_USER_LOGIN, ROUTE_USER_LOGOUT } from '../../constants/route';
import { ApolloClientPromoService } from '../../services/ApolloClientPromoService';

/**
 * Login action
 * @param {*} param0
 * @param {*} dispatch
 * @param {*} navigate
 */
export const userLoginAction = async ({ input }, dispatch, navigate) => {
  try {
    const { data } = await PromoServiceApolloConnector.mutate({
      mutation: USER_LOGIN,
      variables: { input },
      fetchPolicy: 'network-only',
    });
    const response = data?.login || {};
    const { token, user } = response || {};

    if (token && user?._id) {
      dispatch(setUser(user) || {});
      setCookieItem(AUTH_TOKEN, token);
      navigate('/dashboard');
    } else {
      dispatch(setUser('Something went wrong, Try again later...'));
    }
    return response;
  } catch (error) {
    dispatch(setErrorMsg(error?.message || 'Something went wrong...'));
    errorHandling(error);
  }
  // unset error msg after 5s
  setTimeout(() => {
    dispatch(setErrorMsg(null));
  }, 3500);
};

/**
 * Profile action
 * @param {*} param0
 * @param {*} dispatch
 * @param {*} navigate
 */
export const userProfileAction = async (dispatch) => {
  try {
    const { data } = await PromoServiceApolloConnector.query({
      query: USER_PROFILE,
      operationName: 'USER_PROFILE',
      fetchPolicy: 'network-only',
    });
    const user = data?.profile || {};

    if (user) {
      dispatch(setUser(user || {}));
    } else {
      dispatch(setUser({}));
      dispatch(setErrorMsg('Something went wrong...'));
    }
    return user;
  } catch (error) {
    dispatch(setErrorMsg(error?.message || 'Something went wrong...'));
    errorHandling(error);
  }
};

/**
 * Logout action
 * @param {*} dispatch
 */
export const userLogoutAction = async (dispatch) => {
  try {
    deleteCookieItem(AUTH_TOKEN);
    dispatch(setUser({}));
    dispatch(setErrorMsg('Successfully logged out. See you soon!'));
    // unset error msg after 5s
    setTimeout(() => {
      dispatch(setErrorMsg(null));
      window.location.href = ROUTE_USER_LOGIN;
    }, 3000);
  } catch (error) {}
};

export const createOrUpdateUser = async (input) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: CREATE_OR_UPDATE_USER,
      operationName: 'CREATE_OR_UPDATE_USER',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const user = data?.createOrUpdateUser || {};
    return user;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const updateDashboardSettings = async (input) => {
  try {
    const { data } = await ApolloClientPromoService.mutate({
      mutation: UPDATE_DASHBOARD_SETTINGS,
      operationName: 'UPDATE_DASHBOARD_SETTINGS',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const user = data?.updateDashboardSettings || {};
    return user;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};

export const getUsers = async (input) => {
  try {
    const { data } = await ApolloClientPromoService.query({
      query: GET_USERS,
      operationName: 'GET_USERS',
      fetchPolicy: 'network-only',
      variables: input,
    });
    const users = data?.users || {};
    return users;
  } catch (error) {
    console.log(error);
    errorHandling(error);
  }
};
